export default "__VITE_ASSET__ac5f78c6__"